export default __webpack_public_path__ + "static/media/mic-off.eed4bc25.svg";